/*
Ashraf 01/20/2023 2698088984 added form for view candidates

*/
import {Card} from '@material-ui/core';
import React, {useContext} from 'react';
import LandingPage from '../../../../../Pages/LandingPage';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import CreateAccount from './AccountForm';
function index() {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const tabLabels = [];
  return (
    <>
      <LandingPage showTabs={true} title={'Operations'} tabValue={value} handleTabChange={handleChange} allAntTabs={tabLabels}>
        <div className={`global-field-dash-board`}>
          <Card className={`${classes.cardBordernoneStyles} rounded`} elevation={0}>
            <CreateAccount />
          </Card>
        </div>
      </LandingPage>
    </>
  );
}

export default index;
